/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';

interface WidgetsTableComponentArgs {
  title: string;
  tableHeaderData: string[];
  fetchTask: Task<unknown, []>;
  fetchErrorMessage: string;
  headerAriaLabelledBy: string;
  loaderIcon?: string;
  tryAgainIcon?: string;
  testId?: string;
}

export default class WidgetsTableComponent extends Component<WidgetsTableComponentArgs> {}
